import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Modal } from '@calendly/ui/components/modal';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { modalRootStackingCss } from 'shared/modal_stacking';
const panelIsPhoneCss = "pvhzaz4";
const panelIsTabletUpCss = "p1xp65zi";
const panelCss = "p15unukn";
const closeButtonCss = "cbnzqlu";

/**
 * Host-reschedule dialogs must use Modal (not Popup): Popup does not forward className,
 * so modal stacking cannot be raised above the mobile side panel (FixedContainer stays at z-index 15).
 */
export const RescheduleFlowModal = ({
  ariaLabel = I18n.t('publisher.rescheduling_flow.title'),
  children,
  isOpen,
  onClose,
  withCloseButton = false
}) => {
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Modal isOpen={isOpen} onClose={onClose} className={modalRootStackingCss} aria-label={ariaLabel}>
      <div className={classNames(panelCss, {
      [panelIsPhoneCss]: isPhone,
      [panelIsTabletUpCss]: isTabletUp
    })}>
        {withCloseButton && <IconButton className={closeButtonCss} title={I18n.t('publisher.action.close')} size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>}
        {children}
      </div>
    </Modal>;
};
RescheduleFlowModal.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  withCloseButton: PropTypes.bool
};

require("./reschedule_flow_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./reschedule_flow_modal.js");